import BsPageTableWrapper from './index.vue'
export default BsPageTableWrapper